export interface UpdateCurrentStep {
    categoryId: number;
    subCategory?: string;
    currentStepId: string;
}
